import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// Legacy route: /Reports/ViewVendor. The row detail reuses Purchase/GetVerificationVendorbyCode
// (getVendorDetailsByCode in PurchaseAPI/vendorCreationAPI.js).

const base = API_BASE_URL;

const handle = (err, fallback) => {
    if (err.response?.data) throw err.response.data;
    throw err.message || fallback;
};

// MSME vendors of a type, for the vendor dropdown. Rows: { Type: VendorCode, Desc: "code,name" }
export const getVendorsBySearch = async (VenType, SearchType) => {
    try {
        const res = await axios.get(`${base}/Reports/GetVendorsbySearch`, { params: { VenType, SearchType } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch vendors'); }
};

// All 4 params must be present for Web API to match the action:
//   MSME     -> Vendor = vendor code or 'SelectAll', Prefix = ''
//   NonMSME  -> Prefix = first letter of the vendor name, Vendor = ''
export const getVendorReport = async ({ Prefix, Vendortype, Searchbytype, Vendor }) => {
    try {
        const res = await axios.get(`${base}/Reports/GetVendorReport`, {
            params: { Prefix: Prefix || '', Vendortype, Searchbytype, Vendor: Vendor || '' },
        });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch vendors'); }
};
